export default __webpack_public_path__ + "static/media/background-video.37d579ed.mp4";